"use client";

import React from "react";

const BRAND = "#F48428";

function Bullet({ text }) {
    return (
        <div className="d-inline-flex align-items-center gap-2 me-3 mb-2">
            <span className="d-inline-flex align-items-center justify-content-center" style={{ width: 22, height: 22, borderRadius: 999, border: `1px solid ${BRAND}`, color: BRAND }}>
                <i className="fa-solid fa-check" style={{ fontSize: 11 }}></i>
            </span>
            <span className="text-white-50" style={{ fontWeight: 600 }}>{text}</span>
        </div>
    );
}

function TechBadge({ icon, label, color }) {
    return (
        <div
            className="d-inline-flex align-items-center justify-content-center"
            title={label}
            style={{
                width: 72,
                height: 72,
                borderRadius: 18,
                background: `${BRAND}12`,
                color: color || "#fff",
                border: `1px solid ${BRAND}25`,
            }}
        >
            <i className={icon} style={{ fontSize: 32 }}></i>
        </div>
    );
}

export default function MobileExpertise() {
    const boxStyle = {
        borderColor: "rgba(255,255,255,0.12)",
        background: "rgba(255,255,255,0.02)",
        width: "100%",
    };
    return (
        <section className="py-5">
            <div className="container">
                <div className="text-center mb-4">
                    <div className="text-uppercase small" style={{ letterSpacing: ".18em", color: BRAND }}>Our Expertise With Major Mobile App Development Technologies</div>
                </div>

                {/* iOS Application Development */}
                <div className="border rounded-4 p-3 p-md-4 w-100" style={boxStyle}>
                    <div className="row g-3 align-items-center">
                        <div className="col-12 col-md-9">
                            <h3 className="h4 fw-bold text-white mb-1">iOS Application Development</h3>
                            <p className="text-secondary mb-3">Get a feature‑rich, high‑performing iOS app that caters to both startups and established businesses.</p>
                            <div className="d-flex flex-wrap">
                                <Bullet text="iPhone App Development" />
                                <Bullet text="iPad App Development" />
                                <Bullet text="Apple Watch App Development" />
                                <Bullet text="Apple TV App Development" />
                                <Bullet text="App Clips Development" />
                            </div>
                        </div>
                        <div className="col-12 col-md-3">
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 72px)', gap: 12, justifyContent: 'end' }}>
                                <TechBadge icon="fa-brands fa-apple" label="Apple/iOS" color="#ffffff" />
                                <TechBadge icon="fa-solid fa-code" label="Objective‑C / C" color="#f0f0f0" />
                                <TechBadge icon="fa-solid fa-box" label="CocoaPods" color="#ffebcd" />
                                <TechBadge icon="fa-solid fa-wave-square" label="RxSwift" color="#d56bff" />
                                <TechBadge icon="fa-solid fa-layer-group" label="SwiftUI" color="#9cd3ff" />
                                <TechBadge icon="fa-solid fa-arrow-rotate-right" label="CI/CD" color="#e0e0e0" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Android Application Development */}
                <div className="border rounded-4 p-3 p-md-4 mt-3 w-100" style={boxStyle}>
                    <div className="row g-3 align-items-center">
                        <div className="col-12 col-md-9">
                            <h3 className="h4 fw-bold text-white mb-1">Android Application Development</h3>
                            <p className="text-secondary mb-3">We build feature‑rich Android applications leveraging the full power of the Android ecosystem.</p>
                            <div className="d-flex flex-wrap">
                                <Bullet text="Android Mobile App Development" />
                                <Bullet text="Android Tablet App Development" />
                                <Bullet text="Android TV App Development" />
                                <Bullet text="Android Wear App Development" />
                                <Bullet text="Play Console Release & CI/CD" />
                            </div>
                        </div>
                        <div className="col-12 col-md-3">
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 72px)', gap: 12, justifyContent: 'end' }}>
                                <TechBadge icon="fa-brands fa-android" label="Android" color="#7ad97a" />
                                <TechBadge icon="fa-solid fa-bolt" label="Kotlin" color="#ff7a00" />
                                <TechBadge icon="fa-brands fa-java" label="Java" color="#f0a354" />
                                <TechBadge icon="fa-solid fa-diagram-project" label="Jetpack" color="#8bd4ff" />
                                <TechBadge icon="fa-solid fa-layer-group" label="Compose" color="#9cd3ff" />
                                <TechBadge icon="fa-solid fa-arrow-rotate-right" label="CI/CD" color="#e0e0e0" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Hybrid App Development */}
                <div className="border rounded-4 p-3 p-md-4 mt-3" style={{ borderColor: "rgba(255,255,255,0.12)", background: "rgba(255,255,255,0.02)" }}>
                    <div className="row g-3 align-items-center">
                        <div className="col-12 col-md-9">
                            <h3 className="h4 fw-bold text-white mb-1">Hybrid App Development</h3>
                            <p className="text-secondary mb-3">Develop robust cross‑platform apps blending native features with web technologies.</p>
                            <div className="d-flex flex-wrap">
                                <Bullet text="Hybrid Mobile App Development" />
                                <Bullet text="Hybrid Tablet App Development" />
                                <Bullet text="Hybrid TV App Development" />
                                <Bullet text="Performance Tuning & Native Modules" />
                                <Bullet text="Store Deployment & CI/CD" />
                            </div>
                        </div>
                        <div className="col-12 col-md-3">
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 72px)', gap: 12, justifyContent: 'end' }}>
                                <TechBadge icon="fa-brands fa-js" label="JavaScript" color="#f7df1e" />
                                <TechBadge icon="fa-brands fa-react" label="React Native" color="#61dafb" />
                                <TechBadge icon="fa-brands fa-vuejs" label="Vue" color="#42b883" />
                                <TechBadge icon="fa-brands fa-angular" label="Angular" color="#e53935" />
                                <TechBadge icon="fa-solid fa-mobile-screen" label="Flutter" color="#7bdcff" />
                                <TechBadge icon="fa-solid fa-diagram-project" label="Redux" color="#9b7cff" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* PWA Application Development */}
                <div className="border rounded-4 p-3 p-md-4 mt-3" style={{ borderColor: "rgba(255,255,255,0.12)", background: "rgba(255,255,255,0.02)" }}>
                    <div className="row g-3 align-items-center">
                        <div className="col-12 col-md-9">
                            <h3 className="h4 fw-bold text-white mb-1">PWA Application Development</h3>
                            <p className="text-secondary mb-3">Bridge the gap between web and mobile with app‑like experiences accessible in the browser.</p>
                            <div className="d-flex flex-wrap">
                                <Bullet text="Cross‑browser Web App Development" />
                                <Bullet text="Responsive Web App Development" />
                                <Bullet text="Offline Web App Development" />
                                <Bullet text="Installable (Add to Home Screen)" />
                                <Bullet text="Push Notifications & Background Sync" />
                            </div>
                        </div>
                        <div className="col-12 col-md-3">
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 72px)', gap: 12, justifyContent: 'end' }}>
                                <TechBadge icon="fa-brands fa-js" label="JavaScript" color="#f7df1e" />
                                <TechBadge icon="fa-brands fa-react" label="React" color="#61dafb" />
                                <TechBadge icon="fa-brands fa-angular" label="Angular" color="#e53935" />
                                <TechBadge icon="fa-brands fa-vuejs" label="Vue" color="#42b883" />
                                <TechBadge icon="fa-solid fa-layer-group" label="Next.js" color="#c9d1d9" />
                                <TechBadge icon="fa-solid fa-bolt" label="Service Worker" color="#ffd166" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
